import { stripManufacturingOrderPrefix } from "../../../utils/manufacturingOrderCode";

export interface ManufacturingOrderSelectionCandidate {
    id: string;
    is_current_order?: boolean;
    is_already_in_manufacturing_order?: boolean;
    has_required_factory_assignment?: boolean;
}

export interface ManufacturingOrderSelectionGroup {
    recommended_sale_order_ids?: string[];
    candidates?: ManufacturingOrderSelectionCandidate[];
}

export interface ManufacturingOrderDisplay {
    manufacturing_order_code?: string | null;
    manufacturing_order_number?: number | string | null;
}

export const formatManufacturingOrderDisplayName = (
    manufacturingOrder: ManufacturingOrderDisplay,
) => {
    const code = stripManufacturingOrderPrefix(
        manufacturingOrder?.manufacturing_order_code,
    );
    return code || "Chưa có mã";
};

export const getRecommendedManufacturingCandidateIds = (
    group: ManufacturingOrderSelectionGroup,
) => {
    if (Array.isArray(group.recommended_sale_order_ids)) {
        return group.recommended_sale_order_ids.filter(Boolean);
    }

    const eligibleIds = (group.candidates || [])
        .filter((candidate) => candidate.has_required_factory_assignment || candidate.is_already_in_manufacturing_order)
        .map((candidate) => candidate.id);
    if (eligibleIds.length > 0) return eligibleIds;

    return (group.candidates || [])
        .filter((candidate) => candidate.is_current_order || candidate.is_already_in_manufacturing_order)
        .map((candidate) => candidate.id);
};
